// ============================================
// WebSocket Service - Real-time Updates
// ============================================

import { io } from 'socket.io-client';

// Detect environment and construct Socket URL (evaluated at runtime)
const getSocketUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3001';
    }
  }
  return 'https://api.steaming-th.com';
};

// Lazy evaluation
let _socketUrl = null;
const getSocketUrlCached = () => {
  if (_socketUrl === null) {
    _socketUrl = getSocketUrl();
    console.log('Socket URL:', _socketUrl);
  }
  return _socketUrl;
};

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = {};
  }

  connect() {
    if (!this.socket) {
      this.socket = io(getSocketUrlCached(), {
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5
      });

      this.socket.on('connect', () => {
        console.log('WebSocket connected');
      });

      this.socket.on('disconnect', () => {
        console.log('WebSocket disconnected');
      });

      this.socket.on('connect_error', (error) => {
        console.error('WebSocket connection error:', error);
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
      if (this.listeners[event]) {
        this.listeners[event] = this.listeners[event].filter(
          cb => cb !== callback
        );
      }
    }
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  // Specific listeners
  onPriceUpdate(callback) {
    this.on('price_update', callback);
  }

  onTransactionApproved(callback) {
    this.on('transaction_approved', callback);
  }

  onActivityLog(callback) {
    this.on('activity_log', callback);
  }
}

const socketService = new SocketService();
export default socketService;
